// --- SaniQ ---
import * as AppConstants from '../constants';
import {fetchAPI} from "api";
import {DeserializedRecord} from "../../../models/Helpers";
import {parseEvent} from "src/modules/dashboard/helpers/Events";
import {handleResponse} from "helpers/Requests";
import {deserializeTriggerEventCount} from "../../../models/trigger/event/Count";
import {
  increaseEventsCount,
  increaseMessagesCount,
  setEventsCount,
  setIncomingECGsCount,
  setMessagesCount,
  setTasksCount
} from "../reducers/Indicators";
import {showIncomingECGsCount} from "../../dashboard/requests/IncomingEcgs";
import {showTaskCount} from "../../dashboard/requests/TaskCount";

interface MessagesCount extends DeserializedRecord<"count"> {
  count: number;
}

function fetchMessagesCount() {
  return dispatch => {
    const url = '/web/v1/messages/counts';

    return fetchAPI(url, 'GET')
      .then(handleResponse<MessagesCount>())
      .then(({content}) => {
        dispatch(setMessagesCount(content.count));
      });
  };
}

function receiveMessage(message) {
  return dispatch => {
    dispatch(increaseMessagesCount(1));
    dispatch({
      type: AppConstants.RECEIVE_MESSAGE,
      message: message.message
    });
  };
}

function fetchEventsCount() {
  return dispatch => {
    const url = '/web/v1/patients/triggers/events/counts';

    return fetchAPI(url, 'GET')
      .then(handleResponse(deserializeTriggerEventCount, false))
      .then((count) => {
        dispatch(setEventsCount(count.content));
      });
  };
}

function fetchIncomingEcgsCount() {
  return dispatch => {
    showIncomingECGsCount()
      .then(({content}) => {
        dispatch(setIncomingECGsCount(content));
      });
  };
}

function fetchTasksCount() {
  return dispatch => {
    showTaskCount()
      .then(({content}) => {
        dispatch(setTasksCount(content));
      });
  };
}

function receiveEvent(eventContent) {
  return dispatch => {
    dispatch(increaseEventsCount(1));
    dispatch({
      type: AppConstants.RECEIVE_EVENT,
      event: parseEvent(eventContent.data, eventContent.included)
    });
  };
}

export {
  fetchIncomingEcgsCount,
  fetchMessagesCount,
  fetchTasksCount,
  receiveMessage,
  fetchEventsCount,
  receiveEvent
};
